import axios from "axios";

export const fetchGetTaskCounterCompanies = async () => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.get(`${baseTaskUrl}/TaskCounterTemplate/companies`);
};

export const fetchGetTaskCounterOrganizations = async () => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.get(`${baseTaskUrl}/TaskCounterTemplate/organizations`);
};

export const fetchGetTaskCounterOrganizationsByCompany = async (companyId: string) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.get(`${baseTaskUrl}/TaskCounterTemplate/organizations-by-company/${companyId}`);
};
